import QRCode from 'react-qr-code';
import { theme } from 'assets/themes/zizzi';
import { useMediaQuery } from '@mui/material';
import { StyledContent, Text, StyledModal } from './QRModal.styles';

export interface QRModalProps {
  isOpen: boolean;
  onClose: () => void;
  title: string;
  code: string;
  description?: string;
}

function useQRSize() {
  const isXSmall = useMediaQuery('(max-width: 349px)');
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  if (isXSmall) return 150;
  if (isMobile) return 220;

  return 300;
}

function QRModal({ isOpen, onClose, title, description, code }: QRModalProps) {
  const QRSize = useQRSize();

  return (
    <StyledModal open={isOpen} onClose={onClose} closeType="close" aria-label="QR Modal">
      <StyledContent>
        <QRCode fgColor={theme.palette.primary.main} value={code} size={QRSize} level="M" />
        <Text variant="body1">{title}</Text>
        {description && <Text variant="body1">{description}</Text>}
      </StyledContent>
    </StyledModal>
  );
}

export default QRModal;
